export const mantineTheme = {
  colors: {
    milwaukee: [
      '#D2B3B7',
      '#CA989E',
      '#C77B84',
      '#CA5B69',
      '#D2384B',
      '#D91931',
      '#DB011C',
      '#B11528',
      '#92212F',
      '#792832',
      '#652B32',
      '#562C31',
      '#4A2B2F',
    ],
  },
  primaryColor: 'milwaukee',
  fontFamily: 'Barlow Condensed semi-bold, sans-serif',
  fontSize: '20px',
  fontWeight: '600',
  breakpoints: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1350px',
    xl: '1408px',
  },
};
